<script>
/* eslint-disable vue/multi-word-component-names */
export default {
  name: 'Timer',
  props: ['starttime', 'endtime', 'wordString'],
  data() {
    return {
      timer: '',
      start: '',
      end: '',
      interval: '',
      days: '',
      minutes: '',
      hours: '',
      seconds: '',
      message: '',
      statusType: '',
      statusText: '',
    };
  },
  mounted() {
    this.start = new Date(this.starttime).getTime();
    this.end = new Date(this.endtime).getTime();

    // Update the count down every 1 second
    this.timerCount(this.start, this.end);
    this.interval = setInterval(() => {
      this.timerCount(this.start, this.end);
    }, 1000);
  },

  methods: {
    timerCount(start, end) {
      // Get todays date and time
      const now = new Date().getTime();

      // Find the distance between now an the count down date
      const distance = start - now;
      const passTime = end - now;

      if (distance < 0 && passTime < 0) {
        this.message = this.wordString.expired;
        this.statusType = "Time's Up";
        this.statusText = this.wordString.status.expired;
        clearInterval(this.interval);
      } else if (distance < 0 && passTime > 0) {
        this.calcTime(passTime);
        this.message = this.wordString.running;
        this.statusType = 'Still going';
        this.statusText = this.wordString.status.running;
      } else if (distance > 0 && passTime > 0) {
        this.calcTime(distance);
        this.message = this.wordString.upcoming;
        this.statusType = 'We will be back!';
        this.statusText = this.wordString.status.upcoming;
      }
    },
    calcTime(dist) {
      // Time calculations for days, hours, minutes and seconds
      this.days = Math.floor(dist / (1000 * 60 * 60 * 24));
      this.hours = Math.floor(
        (dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      this.minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((dist % (1000 * 60)) / 1000);
    },
  },
};
</script>

<template>
  <div>
    <div v-show="statusType !== 'expired'">
      <div class="day">
        <span class="number">{{ days }}</span>
        <div class="format">{{ wordString.day }}</div>
      </div>
      <div class="hour">
        <span class="number">{{ hours }}</span>
        <div class="format">{{ wordString.hours }}</div>
      </div>
      <div class="min">
        <span class="number">{{ minutes }}</span>
        <div class="format">{{ wordString.minutes }}</div>
      </div>
      <div class="sec">
        <span class="number">{{ seconds }}</span>
        <div class="format">{{ wordString.seconds }}</div>
      </div>
    </div>
    <div class="message">{{ message }}</div>
    <div class="status-tag" :class="statusType">{{ statusText }}</div>
  </div>
</template>

<style lang="sass" scoped>
.timer
  font-size: 20px
  color: #ededed
  text-align: center

  .day,
  .hour,
  .min,
  .sec
    font-size: 30px
    display: inline-block
    font-weight: 500
    text-align: center
    margin: 0 5px
    .format
      font-weight: 300
      font-size: 14px
      display: inline-block
      opacity: 0.8
      width: 60px
  .number
    background: rgba(51, 51, 51, 0.53)
    padding: 0 5px
    border-radius: 5px
    display: inline-block
    width: 60px
    text-align: center
  .message
    font-size: 14px
    font-weight: 400
    margin-top: 5px
    color: #3995a3
  .status-tag
    margin: 10px auto
    padding: 8px 0
    font-weight: 500
    color: #ededed
    text-align: center
    border-radius: 15px
    &.upcoming
      background-color: lightGreen
    &.running
      background-color: gold
    &.expired
      background-color: silver

</style>
